import { z } from 'zod';

export const AdSkipsBalanceSchema = z.object({
  skips: z.number().int().min(0),
});
export type AdSkipsBalance = z.infer<typeof AdSkipsBalanceSchema>;

export const AdSkipsEarnBodySchema = z.object({
  /** Idempotency key for the rewarded-ad reward. Retries with the same id never double-credit. */
  transactionId: z.string().min(1),
  /** Skips to credit. Sent by the client from the `testAdSkips` payload; server only clamps to [1,10] (not tamper-safe). */
  amount: z.number().int().min(1).max(10),
  /** Surface that triggered the earn, e.g. 'pread_screen' | 'more_screen'. */
  source: z.string().optional(),
  metadata: z
    .object({
      adProvider: z.string().optional(),
      placement: z.string().optional(),
    })
    .optional(),
});
export type AdSkipsEarnBody = z.infer<typeof AdSkipsEarnBodySchema>;

export const AdSkipsEarnResponseSchema = z.object({
  skips: z.number().int().min(0),
  /** Amount actually credited by the server (0 when the transaction was a deduped no-op). */
  credited: z.number().int().min(0),
});
export type AdSkipsEarnResponse = z.infer<typeof AdSkipsEarnResponseSchema>;

export const AdSkipsSpendBodySchema = z.object({
  /** Idempotency key for this spend (e.g. the countdown unlock id). Retries never double-spend. */
  transactionId: z.string().min(1),
  /** Skips this unlock costs (0 = free). Sent by the client from the `testAdSkips` payload; server only clamps to [0,10]. */
  cost: z.number().int().min(0).max(10),
  seriesId: z.string().optional(),
  episodeId: z.string().optional(),
  source: z.string().optional(),
});
export type AdSkipsSpendBody = z.infer<typeof AdSkipsSpendBodySchema>;

export const AdSkipsSpendResponseSchema = z.object({
  skips: z.number().int().min(0),
  /** True when a skip was consumed; false when the spend was a deduped no-op. */
  spent: z.boolean(),
});
export type AdSkipsSpendResponse = z.infer<typeof AdSkipsSpendResponseSchema>;
